import { ApiModule } from '@common/index';

export class ExportApi extends ApiModule {
  protected endpoint = '/export-data';

  public loadSubjectExportDetails() {
    return this.api.get<Blob>(`${this.endpoint}/subject/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }

  public loadLessonExportDetails() {
    return this.api.get<Blob>(`${this.endpoint}/lesson/xls?&sampleUnitId=`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }

  public loadEntreatyExportDetails() {
    return this.api.get<Blob>(`${this.endpoint}/entreaty/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }

  public loadEntreatyListExportDetails() {
    return this.api.get<Blob>(`${this.endpoint}/entreaty-list/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }

  public loadCheckDataExportDetails() {
    return this.api.get<Blob>(`${this.endpoint}/check-data/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }

  public loadMissingValidationExportDetails() {
    return this.api.get<Blob>(`${this.endpoint}/missing-validations/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }

  public educationalRequirementExportDetails() {
    return this.api.get<Blob>(`${this.endpoint}/educational-requirement/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }

  public clinicalSkillExportDetails() {
    return this.api.get<Blob>(`${this.endpoint}/clinical-skill/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }

  public sampleCurriculumExportDetails() {
    return this.api.get<Blob>(`${this.endpoint}/sample-curriculum/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }

  public courseExportDetails() {
    return this.api.get<Blob>(`${this.endpoint}/course/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }

  public courseNeptunSubjectThematicDetails() {
    return this.api.get<Blob>(`${this.endpoint}/neptun-subject-thematic/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }

  public programBookExportDetails(filterData: any) {
    return this.api.get<Blob>(
      `${this.endpoint}/program-book/docx?modules=${filterData.modules}&semesters=${filterData.semesters}&specialityId=${filterData.speciality}&headerText=${filterData.headerText}&footerText=${filterData.footerText}&titlePageText=${filterData.titlePageText}`,
      {
        headers: {
          Accept: 'application/docx'
        },
        responseType: 'blob'
      }
    );
  }

  public programBookCalculateCount(filterData: any) {
    return this.api.get<number>(
      `${this.endpoint}/program-book/calculate-count?modules=${filterData.modules}&semesters=${filterData.semesters}&specialityId=${filterData.speciality}`
    );
  }

  public discontinuedSubjectsExportDetails(filterData: any) {
    const params = new URLSearchParams();

    if (filterData.topicId) params.append('topicId', filterData.topicId);
    if (filterData.sampleUnitId) params.append('sampleUnitId', filterData.sampleUnitId);
    if (filterData.subjectId) params.append('subjectId', filterData.subjectId);
    if (filterData.academicYears) params.append('academicYears', filterData.academicYears);
    if (filterData.owner) params.append('owner', filterData.owner);
    if (filterData.institute) params.append('institute', filterData.institute);

    return this.api.get<Blob>(`${this.endpoint}/discontinued-subjects?${params.toString()}`, {
      headers: {
        Accept: 'application/pdf'
      },
      responseType: 'blob'
    });
  }

  public cmsIntegrationExportDetails() {
    return this.api.get<Blob>(`${this.endpoint}/cms-integration/csv`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }

  public sampleUnitCurriculumExportPdf(id: number) {
    return this.api.get<Blob>(`${this.endpoint}/sample-unit/pdf?id=${id}`, {
      headers: {
        Accept: 'application/pdf'
      },
      responseType: 'blob'
    });
  }

  public methodologicalElementsAndFeedbackDetails() {
    return this.api.get<Blob>(`${this.endpoint}/methodological-elements-and-feedback/xls`, {
      headers: {
        Accept: 'application/pdf'
      },
      responseType: 'blob'
    });
  }

  public knowledgeAbilityAttitudeExportDetails() {
    return this.api.get<Blob>(`${this.endpoint}/knowledge-ability-attitude/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }

  public lessonsDataExportDetails() {
    return this.api.get<Blob>(`${this.endpoint}/lessons-data/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }

  public instituteExportDetails() {
    return this.api.get<Blob>(`${this.endpoint}/institute/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }

  public userExportDetails() {
    return this.api.get<Blob>(`${this.endpoint}/user/xls`, {
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      responseType: 'blob'
    });
  }
}
